import { Typography } from '@mui/material'
import { InsightItem } from 'components/core/insights'
import { Outcome, UserPropOutcome } from 'pbts/c1/api/analysis/v1/analysis'
import { InsightType } from 'pbts/c1/api/task/v1/insights'
import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'

export type GrantsUserProps = {
    outcome: Outcome | undefined
    insightType: InsightType
    showIcon?: boolean
}

export type GrantsUserLabelProps = {
    outcome: Outcome | undefined
}

export const ReviewUserPropTitleLabel: FC<GrantsUserProps> = ({ outcome, insightType }) => {
    if (!outcome?.outcome) {
        return null
    }
    const userPropOutcome = outcome.outcome as unknown as UserPropOutcome
    if (insightType !== InsightType.NEGATIVE || userPropOutcome.input?.userProp?.key !== 'title' || !userPropOutcome.input?.userProp?.value) {
        return null
    }
    return (
        <Typography>
            <FormattedMessage
                id="analysis_insights_grants_user"
                defaultMessage="Users with the job title {prop_value} don't usually have this access"
                values={{
                    prop_value: userPropOutcome.input.userProp.value,
                }}
            />
        </Typography>

    )
}

const GrantsUserLabel: FC<GrantsUserLabelProps> = ({ outcome }) => {
    if (!outcome?.outcome) {
        return null
    }
    const userPropOutcome = outcome.outcome as unknown as UserPropOutcome
    if (!userPropOutcome.input) {
        return null
    }
    if (!userPropOutcome.input.relevance) {
        return null
    }
    if (!userPropOutcome.input.userProp) {
        return null
    }
    return (
        <Typography>
            <FormattedMessage
                id="analysis_insights_grants_user"
                defaultMessage="{group_with_access} out of {num_in_group} users with the {prop_key} {prop_value} have this entitlement"
                values={{
                    group_with_access: userPropOutcome.input.relevance.groupWithAccess,
                    num_in_group: userPropOutcome.input.relevance.numInGroup,
                    prop_key: userPropOutcome.input.userProp.key,
                    prop_value: userPropOutcome.input.userProp.value,
                }}
            />
        </Typography>

    )
}

export const GrantsUser: FC<GrantsUserProps> = ({ outcome, insightType, showIcon = true }) => {
    if (!outcome?.outcome) {
        return null
    }
    const userPropOutcome = outcome.outcome as unknown as UserPropOutcome
    if (!userPropOutcome.input) {
        return null
    }
    if (!userPropOutcome.input.relevance) {
        return null
    }
    if (!userPropOutcome.input.userProp) {
        return null
    }
    if (!showIcon) {
        return <GrantsUserLabel outcome={outcome} />
    }
    return (
        <InsightItem key="grants_account_item" insightType={insightType}>
            <GrantsUserLabel outcome={outcome} />
        </InsightItem>
    )
}
